import { render } from "./InputListObject.vue?vue&type=template&id=dcb1e630&scoped=true"
import script from "./InputListObject.vue?vue&type=script&lang=ts"
export * from "./InputListObject.vue?vue&type=script&lang=ts"

import "./InputListObject.vue?vue&type=style&index=0&id=dcb1e630&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-dcb1e630"

export default script